'use client';

import { ISiteSectionEntry } from '@move-frontend/contentful';
import {
	IPageLayoutProps,
	PageLayout,
} from '../../../shared/layout/page/PageLayout';
import { IPageSectionEntry } from '../../../../contentful';
import { renderSectionComponent } from '../../../content-sections/ui';
import PageHeader from '../../../../components/common/header/PageHeader';
import { IPageEntry } from '../../../../contentful/types/IPage';

export interface IGenericPageProps extends IPageLayoutProps {
	page: IPageEntry;
	siteSection?: ISiteSectionEntry;
	childrenFirst?: boolean;
	titleTop?: boolean;
}

export default function GenericPage({
	page,
	siteSection,
	children,
	childrenFirst = false,
	titleTop = false,
	...rest
}: IGenericPageProps) {
	return (
		<PageLayout {...rest}>
			<PageHeader page={page} titleTop={titleTop} siteSection={siteSection} />
			{childrenFirst && children}

			<div>
				{page?.fields?.sections?.map((section: IPageSectionEntry) =>
					renderSectionComponent(section),
				)}
			</div>

			{!childrenFirst && children}
		</PageLayout>
	);
}
